export default "__VITE_PUBLIC_ASSET__e6edd1b7__"